enum CalcTrigger {
  KAUFPREIS ='updateKaufpreis',
  DARLEHEN = 'updateDarlehen',
  RATE = 'updateRate',
  SONDERTILGUNG = 'updateSondertilgung',
  SOLLZINSBINDUNG = 'updateSollzinsbindung',
  VOLLTILGUNG = 'updateVolltilgung',
  EINNAHMEN = 'updateEinnahmen',
  AUSGABEN = 'updateAusgaben',
  EIGENKAPITAL = 'updateEigenkapital'
}

enum NoCalcTrigger{
    DARLEHEN = 'updateDarlehenAfterKaufpreis'
}

const isCalcTrigger = function (value: string): boolean{
  switch (value){
    case CalcTrigger.KAUFPREIS:
    case CalcTrigger.DARLEHEN:
    case CalcTrigger.RATE:
    case CalcTrigger.SOLLZINSBINDUNG:
    case CalcTrigger.SONDERTILGUNG:
    case CalcTrigger.VOLLTILGUNG:
    case CalcTrigger.EINNAHMEN:
    case CalcTrigger.AUSGABEN:
    case CalcTrigger.EIGENKAPITAL:
      return true;

    case NoCalcTrigger.DARLEHEN:
    default:
      return false;
  }
}

export {CalcTrigger,NoCalcTrigger, isCalcTrigger}
